type Props = {
  body: string
  attribution?: string
  name?: string
  role?: string
  company?: string
  photoUrl?: string
  photoAlt?: string
}

const nameClass =
  "font-['Familjen_Grotesk'] text-[16px] leading-5 tracking-[-0.16px] text-[var(--foreground)]"

const metaClass = 'mt-0.5 text-[14px] leading-[19.25px] text-[var(--foreground-muted)]'

export const EditorialQuote = ({
  body,
  attribution,
  name,
  role,
  company,
  photoUrl,
  photoAlt,
}: Props) => {
  const nameTrim = name?.trim()
  const roleTrim = role?.trim()
  const companyTrim = company?.trim()
  const attributionTrim = attribution?.trim()
  const hasStructuredByline = Boolean(nameTrim || roleTrim || companyTrim)
  const metaLine = [roleTrim, companyTrim].filter(Boolean).join(' · ')
  const portraitAlt =
    photoAlt?.trim() ||
    (nameTrim ? `${nameTrim} portrait` : attributionTrim ? `Portrait of ${attributionTrim}` : 'Client portrait')

  const showFooter =
    Boolean(photoUrl) || hasStructuredByline || Boolean(!hasStructuredByline && attributionTrim)

  return (
    <figure className="m-0">
      <blockquote className="m-0 border-0 p-0">
        <div className="border-l-2 border-[var(--border-strong)] pl-4">
          <p className="text-[15px] font-normal italic leading-relaxed tracking-[-0.16px] text-[var(--foreground)] [text-wrap:pretty]">
            {body}
          </p>
          {showFooter ? (
            <div className="mt-4 flex items-center gap-[10px]">
              {photoUrl ? (
                <img
                  src={photoUrl}
                  alt={portraitAlt}
                  width={32}
                  height={40}
                  loading="lazy"
                  decoding="async"
                  className="ui-image-outline h-10 w-8 shrink-0 rounded-[6px] bg-[#e8e8e8] object-cover"
                />
              ) : null}
              <div className="min-w-0">
                {hasStructuredByline ? (
                  <>
                    {nameTrim ? <p className={nameClass}>{nameTrim}</p> : null}
                    {metaLine ? <p className={metaClass}>{metaLine}</p> : null}
                  </>
                ) : attributionTrim ? (
                  <p className="text-sm leading-snug text-[var(--foreground-muted)]">— {attributionTrim}</p>
                ) : null}
              </div>
            </div>
          ) : null}
        </div>
      </blockquote>
    </figure>
  )
}
